import React from "react";
import { useNavigate } from "react-router-dom";
import Button from "../../common/Button/Button";
import OnboardLayout from "../../layouts/OnboardLayout/OnboardLayout";
import styles from "../../layouts/OnboardLayout/OnboardLayout.module.scss";
import { HomeIcon } from "../../../assets/icons/svgicons";
import { ROUTES } from "../../../routes";

const Maintenance = () => {
  const navigate = useNavigate();

  return (
    <OnboardLayout>
      <div className={styles.onboard_box}>
        <h2>Under maintenance</h2>
        <p className={styles.sub_text}>
          We are performing scheduled maintenance to improve your experience.
          We'll be back soon.
        </p>
        {/* <div className={styles.submit_btn}>
          <Button fluid type="button" onClick={() => navigate(ROUTES.LOGIN)}>
            <HomeIcon /> Back to home
          </Button>
        </div> */}
      </div>
    </OnboardLayout>
  );
};

export default Maintenance;
